import { DraftRepository, GlobalRepository, } from "@adapters/features/Markets/AIF-PMS/Repository";
import AifPmsRepository from "@adapters/features/Markets/AIF-PMS/Repository/AifPms";
import PurchaseRepository from "@adapters/features/Markets/AIF-PMS/Repository/Purchase";
import OrderBookRepository from "@adapters/features/Markets/AIF-PMS/Repository/OrderBook";
import LeadServiceRepository from "@adapters/features/Markets/AIF-PMS/Repository/LeadServices";
import QualityCheckRepository from "@adapters/features/Markets/AIF-PMS/Repository/QualityCheck";
export default (function (http) {
    return {
        aifPms: new AifPmsRepository(http),
        purchase: new PurchaseRepository(http),
        draft: new DraftRepository(http),
        global: new GlobalRepository(http),
        orderBook: new OrderBookRepository(http),
        leadservice: new LeadServiceRepository(http),
        qualityCheck: new QualityCheckRepository(http),
    };
});
